<div class="auth-form mfa-form" *ngIf="email && token">
  <div class="auth-form__header">
    <p
      class="auth-form__description text-center"
      [innerHTML]="
        'UI.Authentication.EnterOTPCode'
          | translate
          | stringReplacement
              : {
                  '{mail}': '<strong>' + email + '</strong>'
                }
        "
      ></p>
  </div>

  <form [formGroup]="form" (ngSubmit)="verify()">
    <div class="form-group">
      <input
        type="text"
        class="form-control otp-input"
        id="otp"
        formControlName="otp"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="6"
        placeholder="_ _ _ _ _ _"
      />
    </div>

    <div class="form-group text-center email-confirmation__buttons mb-3">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="form.invalid || requesting"
      >
        <ng-container *ngIf="requesting">
          <i class="fas fa-spinner fa-spin"></i>
        </ng-container>
        <span class="ml-2">{{ 'Verify' | translate }}</span>
      </button>
    </div>
  </form>

  <p class="auth-form__description text-center mb-0" translate>
    {{ 'UI.Authentication.DidNotReceiveCode' | translate }}
  </p>
  <p class="text-center" (click)="resendCode()">
    <span class="resend-code-btn" [class.disabled]="resendCodeTime > 0"
      >{{ 'UI.Authentication.ResendCode' | translate }}</span
    >({{ resendCodeTime }})
  </p>
</div>
